if (!window.notifyMeInitialized) {
  window.notifyMeInitialized = true;

  const buildNotifyTags = (productHandle, variant) => {
    const handle = productHandle || '';
    const variantSlug = (variant.title || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    return `back-in-stock, variant-${variant.id}, ${handle}-${variantSlug}`;
  };

  const getExcludedVariantIds = (wrapper) => {
    const raw = wrapper.dataset.notifyExcludedVariantIds || '';
    return raw
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  };

  const isExcludedVariant = (wrapper, variant) => {
    if (!variant?.id) return false;
    const variantId = String(variant.id);
    return getExcludedVariantIds(wrapper).includes(variantId);
  };

  document.addEventListener('DOMContentLoaded', () => {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
      const wrapper = document.getElementById(`NotifyMe-${sectionId}`);
      if (!wrapper) return;

      const isSoldOut = !variant || !variant.available;
      const excluded = isExcludedVariant(wrapper, variant);
      wrapper.hidden = !isSoldOut || excluded;

      if (isSoldOut && variant && !excluded) {
        const tagsInput = wrapper.querySelector('[name="contact[tags]"]');
        if (tagsInput) {
          tagsInput.value = buildNotifyTags(wrapper.dataset.productHandle, variant);
        }
      }
    });
  });
}
